import { render, staticRenderFns } from "./PaidLicense.vue?vue&type=template&id=705b5806&"
import script from "./PaidLicense.vue?vue&type=script&lang=js&"
export * from "./PaidLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports